import axiosInstant from '../api';

/**
 * Fetch a PDF from an authenticated API path and open it in a new tab.
 *
 * The tab is opened SYNCHRONOUSLY inside the click gesture — Safari's default
 * popup blocker silently suppresses window.open after an await. The blob URL
 * is revoked on a long delay so slow devices finish loading the viewer.
 *
 * RETHROWS on failure (after closing the pre-opened tab) — callers own the
 * user-facing feedback; a silently vanishing tab is not feedback.
 */
export const openPdfFromApi = async (path: string): Promise<void> => {
  const tab = window.open('', '_blank');
  try {
    const response = await axiosInstant.get(path, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const blobUrl = window.URL.createObjectURL(blob);
    if (tab) {
      tab.location.href = blobUrl;
    } else {
      window.open(blobUrl, '_blank');
    }
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
  } catch (err) {
    if (tab) tab.close();
    console.error('Failed to open PDF:', err);
    throw err;
  }
};
